/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Proxy_Failed_ToastInputs */

const en_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`External Project Import Failed. ${i?.error}`)
};

const fr_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'importation du projet externe. ${i?.error}`)
};

const de_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import des externen Projekts fehlgeschlagen. ${i?.error}`)
};

const it_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione progetto esterno non riuscita. ${i?.error}`)
};

const ru_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт внешнего проекта не удался. ${i?.error}`)
};

const es_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la importación del proyecto externo. ${i?.error}`)
};

const zh_cn2_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部项目导入失败。${i?.error}`)
};

const ja_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部プロジェクトのインポートに失敗しました。${i?.error}`)
};

const hi_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`बाह्य परियोजना आयात विफल। ${i?.error}`)
};

const pt_pt2_iconik_proxy_failed_toast = /** @type {(inputs: Iconik_Proxy_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação do projeto externo falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "External Project Import Failed. {error}" |
*
* @param {Iconik_Proxy_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_failed_toast = /** @type {((inputs: Iconik_Proxy_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_failed_toast(inputs)
	if (locale === "de") return de_iconik_proxy_failed_toast(inputs)
	if (locale === "it") return it_iconik_proxy_failed_toast(inputs)
	if (locale === "ru") return ru_iconik_proxy_failed_toast(inputs)
	if (locale === "es") return es_iconik_proxy_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_failed_toast(inputs)
	if (locale === "ja") return ja_iconik_proxy_failed_toast(inputs)
	if (locale === "hi") return hi_iconik_proxy_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_failed_toast(inputs)
	return en_iconik_proxy_failed_toast(inputs)
});